import { defineAsyncComponent } from 'vue'
export default {
  app: defineAsyncComponent(() => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/layouts/app.vue").then(m => m.default || m)),
  blank: defineAsyncComponent(() => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/layouts/blank.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/layouts/default.vue").then(m => m.default || m))
}